import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ActivityIndicator } from 'react-native-paper'
import { View } from 'react-native'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { BtPlainText } from '@linqpal/components/src/ui'

type AgreementProps = {
  onPress: () => void
  downloading: boolean
}

export const Agreement: React.FC<AgreementProps> = ({
  onPress,
  downloading = false,
}): JSX.Element => {
  const { t } = useTranslation('global')

  const download = () => {
    if (!downloading) {
      onPress()
    }
  }

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <BtPlainText
        style={{
          fontWeight: '500',
          fontSize: 12,
          lineHeight: 20,
        }}
      >
        <Trans i18nKey={'payInvoice.payment-terms-conditions-text'} t={t}>
          <BtPlainText
            style={{
              fontWeight: '500',
              fontSize: 12,
              color: '#668598',
            }}
            onPress={download}
          >
            By clicking “Swipe to agree”, you agree to the Borrower Terms and
            Conditions
          </BtPlainText>
          <BtPlainText
            style={{
              fontWeight: '600',
              fontSize: 12,
              color: commonColors.accentText,
            }}
            onPress={download}
          >
            {' '}
            found here
          </BtPlainText>
        </Trans>
      </BtPlainText>
      {downloading ? <ActivityIndicator style={{ marginLeft: 10 }} /> : null}
    </View>
  )
}
